import type { EditorThemeClasses } from 'lexical';

const NoteEditorTheme: EditorThemeClasses = {
  // Text formatting
  text: {
    bold: 'font-bold',
    italic: 'italic',
    underline: 'underline',
    strikethrough: 'line-through',
  },

  // Paragraph
  paragraph: 'mb-2 last:mb-0',

  // Headings
  heading: {
    h1: 'text-2xl font-bold mb-4 mt-6 first:mt-0',
    h2: 'text-xl font-bold mb-3 mt-5 first:mt-0',
    h3: 'text-lg font-semibold mb-3 mt-4 first:mt-0',
    h4: 'text-base font-semibold mb-2 mt-3 first:mt-0',
    h5: 'text-sm font-semibold mb-2 mt-3 first:mt-0',
    h6: 'text-xs font-semibold mb-2 mt-2 first:mt-0',
  },

  // Lists
  list: {
    ul: 'list-disc list-inside ml-4 mb-2',
    ol: 'list-decimal list-inside ml-4 mb-2',
    listitem: 'mb-1',
    nested: {
      listitem: 'mb-0',
    },
  },

  // Links
  link: 'text-blue-600 hover:text-blue-800 underline cursor-pointer',

  // Quote
  quote: 'border-l-4 border-gray-300 pl-4 italic text-gray-700 my-4',

  // Tables
  table: 'border-collapse border border-gray-300 my-4 w-full',
  tableRow: '',
  tableCell: 'border border-gray-300 p-2 text-left',
  tableCellHeader:
    'border border-gray-300 p-2 font-semibold bg-gray-50 text-left',
};

export default NoteEditorTheme;
